/*
    неправильный url | err.message | недоступен err.response
    403 доступ запрещен | err.message | досутпен err.response.status
    400 неправильные данные в форме | err.response.data
*/
export const errorProcessing = (err, dataAdjustment = null) => {
  let errResult = {
    data: null,
    message: err.message,
    statusCode: null,
  };

  if (err.response) {
    errResult.statusCode = err.response.status;
    if (err.response.status === 400) {
      errResult.data = dataAdjustment
        ? dataAdjustment(err.response.data)
        : err.response.data;
      errResult.message =
        err.response.data && err.response.data.message
          ? err.response.data.message
          : 'Ошибка';
    } else if (err.response.status === 404) {
      errResult.message = 'Страница не найдена';
    } else if (err.response.status === 403) {
      if (err.response.data.error.access) {
         errResult.message = 'У вас нет прав для соверщения данного действия'
      } else {
        errResult.message = 'Ошибка доступа';
      }
    }
  }
  /* 
  if (!errResult.data) {
    // Если это ошибка не связана с неправильным заполнение формы
    // todo сменить alert на вывод общего popup с ошибкой
    alert(errResult.message);
  }
  */
  return errResult;
};
